// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';
import DaireDegistir from 'sections/apartman/DaireDegistir';
import SiteDegistir from 'sections/site/SiteDegistir';
import BildirimRozeti from 'sections/bildirimler/BildirimRozeti';
import useAuth from 'hooks/useAuth';
import { YONETICI } from 'utils/roles';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { kullaniciTipi } = useAuth();

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <SiteDegistir />
      <DaireDegistir />
      {/* Bildirimler modülü Yönetici odaklıdır (bkz. .analiz/bildirimler_notlar_ajanda_v1.md
          Bölüm 1.1); endpoint IsYonetici-only olduğundan bileşen yalnızca Yönetici için
          mount edilir (koşullu hook çağrısı yerine koşullu mount — rules-of-hooks güvenli). */}
      {kullaniciTipi === YONETICI && <BildirimRozeti />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
